import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

// Reveal connection identity, equipment and readings within native tile zooms.
const SCALE_START_ZOOM = 17;
const SCALE_MIN = 0.38;
const SCALE_AT_START = 0.58;
const SCALE_PER_LEVEL = 1.33;
const SCALE_MAX = 2.1;
const LABEL_ZOOM = 18;
const VALUE_ZOOM = 20;

export function HighZoomHandler() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();
    const positionDetails = (event: MouseEvent) => {
      const badge = (event.target as HTMLElement).closest<HTMLElement>('.ha-device-badge');
      if (badge) {
        const bounds = container.getBoundingClientRect();
        const rect = badge.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        badge.classList.toggle('ha-tip-left', center < bounds.left + 120);
        badge.classList.toggle('ha-tip-right', center > bounds.right - 120);
        badge.classList.toggle('ha-tip-above', rect.bottom > bounds.bottom - 135);
        return;
      }
      const marker = (event.target as HTMLElement).closest<HTMLElement>('.custom-div-icon');
      const card = marker?.querySelector<HTMLElement>('.ha-label');
      if (!marker || !card) return;
      const mapBounds = container.getBoundingClientRect();
      const markerBounds = marker.getBoundingClientRect();
      card.classList.toggle('ha-label-left', markerBounds.left > mapBounds.left + mapBounds.width / 2);
      card.classList.toggle('ha-label-top', markerBounds.top < mapBounds.top + 120);
      card.classList.toggle('ha-label-bottom', markerBounds.bottom > mapBounds.bottom - 120);
    };
    const handleZoom = () => {
      const currentZoom = map.getZoom();
      const mapContainer = map.getContainer();

      // Add classes to the map container when at high zoom levels
      mapContainer.classList.toggle('high-zoom-active', currentZoom >= 19);
      mapContainer.classList.toggle('zoom-labels', currentZoom >= LABEL_ZOOM);
      mapContainer.classList.toggle('zoom-equipment', currentZoom >= 19);
      mapContainer.classList.toggle('zoom-values', currentZoom >= VALUE_ZOOM);

      // Keep overview markers small; grow steadily through the detailed zooms.
      const markerScale = Math.max(SCALE_MIN, Math.min(SCALE_MAX, SCALE_AT_START * SCALE_PER_LEVEL ** (currentZoom - SCALE_START_ZOOM)));
      mapContainer.style.setProperty('--marker-scale', String(markerScale));
    };

    // Apply immediately, live during zoom gestures and after zoom animations
    handleZoom();
    map.on('zoom', handleZoom);
    container.addEventListener('mouseover', positionDetails);

    return () => {
      map.off('zoom', handleZoom);
      container.removeEventListener('mouseover', positionDetails);
    };
  }, [map]);

  return null;
}
